import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
import { ArrowRightIcon } from 'lucide-react';
export const Hero: React.FC = () => {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-gradient-to-b from-blue-50 to-white" data-id="element-97">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] opacity-20 pointer-events-none" data-id="element-98">
        <div className="absolute inset-0 bg-gradient-to-r from-remax-blue to-remax-red blur-[100px] rounded-full mix-blend-multiply" data-id="element-99" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-101">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-remax-dark tracking-tight mb-6" data-id="element-102">
            Descubre los 4 Modelos de{' '}
            <span className="text-remax-red" data-id="element-103">REMAX Domus</span>
          </h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl md:text-2xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-104">
            Soluciones web diseñadas para Caracas, potenciadas por{' '}
            <span className="font-semibold text-remax-blue" data-id="element-105">Demand OS</span>
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-106">
            <Button variant="secondary" href="#modelos" className="group text-lg px-8 py-4" data-id="element-107">
              Explorar Modelos
              <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-108" />
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};